const TickWithoutLabel = ({ x, y }) => {
  return (
    <g transform={`translate(${x},${y})`}>
      <text
        x={0}
        y={0}
        dy={16}
        textAnchor="end"
        fill="#666"
        transform="rotate(-35)"></text>
    </g>
  );
};

export default TickWithoutLabel;
